import React, { useState } from 'react'
import MDEditor from '@uiw/react-md-editor'
import { useNavigate } from 'react-router-dom'
import useCreateTask from '../hooks/useCreateTask'
import useCreateTaskObject from '../hooks/useCreateTaskObject'
import useCreateForm from '../hooks/useCreateForm'
import useFormValidate from '../hooks/useFormValidate'

const CreateFrom = ({ formRef, defaultValue = {}, edit }) => {
  let createTaskObject = useCreateTaskObject()
  let createTask = useCreateTask()
  let createFrom = useCreateForm()
  let validate = useFormValidate()
  let navigate = useNavigate()
  const [value, setValue] = useState(defaultValue.description || '')
  let [formFields, status, selectedGroup] = createFrom(defaultValue)

  let handleSubmit = () => {
    try {
      let check = validate(formRef, selectedGroup, status, value)
      if (check) {
        let data = createTaskObject(formRef, selectedGroup, status, value, edit)
        createTask(data, edit)
        navigate('/')
      }
    } catch (error) {
      console.log(error)
    }
  }
  return (
    <form className="flex flex-col gap-y-10" ref={formRef}>
      {formFields.map((field, i) => (
        <div className="flex flex-col gap-y-3 w-full" key={i}>
          <h1 className="text-white font-medium text-lg">{field.label}</h1>
          <field.input.element
            className="pb-2 text-[#dedede] bg-transparent border-b-2 border-[#23272B] outline-none focus:border-[#8b9095] transition-colors"
            {...field.input.props}
          />
        </div>
      ))}
      <div className="flex flex-col gap-y-3 w-full">
        <h1 className="text-white font-medium text-lg">Description</h1>

        <div data-color-mode="dark">
          <MDEditor style={{}} value={value} onChange={setValue} />
        </div>
      </div>
      <button
        type="button"
        onClick={() => {
          handleSubmit()
        }}
        className="bg-[#5051F9] w-full rounded-lg py-2.5 px-3 text-white text-center hover:invert transition-all duration-300"
      >
        {edit ? 'Save ' : 'Create '} task
      </button>
    </form>
  )
}

export default CreateFrom
